import { Component, inject } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { faEdit, faPlus, faTrashAlt, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BreadcrumbService } from 'xng-breadcrumb';
import { IconsService } from 'src/app/shared/services/icons.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-profile-index',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Perfiles y roles</h1>
        <xng-breadcrumb ></xng-breadcrumb>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">
        <ul #subnav app-nav-administration [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="d-flex mb-3">
          <div class="flex-fill ms-2">
            <h2 class="mt-2 mt-md-0 mb-0">Perfiles</h2>
          </div>
        </div>
        <div class="d-flex">
          <div class="flex-fill ms-3 me-3">
            <form [formGroup]="searchBox" (ngSubmit)="searchProfiles($event)">
              <input class="form-control form-control-lg bg-transparent rounded-5" placeholder="Buscar..." formControlName="search">
            </form>
          </div>
          <div>
          </div>
          <div class="text-end">
            <button class="btn btn-zazz-dark" routerLink="create" *ngIf="authService.hasPermission('can_create_companies')">
              <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
              Agregar perfil
            </button>
          </div>
        </div>
        <div class="list-group rounded-4 rounded-md-5 mt-4">
          <div class="list-group-item table-responsive py-4">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3">Nombre</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2">RFC</th>
                  <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">THSM Company</th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2"></th>
                </tr>
              </thead>
              <tbody>   
                <tr app-tr-perfil
                [perfil]="perfil"
                [profile]="profile"
                *ngFor="let perfil of profiles | paginate: { itemsPerPage: payload.per_page, currentPage: p, totalItems: meta.total_entries }"                
                ></tr>
              </tbody>
            </table>
          </div>
          <div class="list-group-item text-center py-5" *ngIf="profiles.length==0&&loading">
            <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
            <p class="text-muted">Cargando...</p>
          </div>
          <div class="list-group-item text-center py-5" *ngIf="profiles.length==0&&!loading">
            <img src="/assets/images/empty-state.png" width="240px">
            <h5 class="text-muted">No se encontraron registros</h5>
          </div>
          <div class="list-group-item text-center pt-3" *ngIf="profiles.length>0">
            <pagination-controls
              (pageChange)="p = $event"
              (pageChange)="pageChanged($event)"
              previousLabel="Prev."
              nextLabel="Sig."
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"                  
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class ProfileIndexComponent {
  loading: boolean = false;
  profiles: any[] = [];
  meta: any = {};
  searchBox: FormGroup = new FormGroup({});
  profile: any = {};
  permissions: any = {};

  currentView: string = 'perfiles';

  payload: any = {
    page: 1,
    per_page: 10,
  };

  p: number = 1;
  storageService = inject(StorageService);
  constructor(
    private store : SettlementsService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private breadcrumbService: BreadcrumbService,
    public icons: IconsService,
    public authService: AuthService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
  }
  

  ngOnInit(): void {
    this.loadProfiles(this.payload);
    this.initForm();
    this.breadcrumbService.set('@amenidad', 'Amenidades');
  }

  loadProfiles(payload: any) {
    this.loading = true;
    this.store.getProfiles(payload).subscribe({
      next: (profiles: any) => {
        this.profiles = profiles.data;
        this.meta = profiles.meta;
        this.loading = false;
      },
      error: (err: any) => {
        console.log(err.status);
        this.loading = false;
        this.profiles = [];
        if (err.status === 500) {
          this.toastr.error('Ocurrió un error al obtener las amenidades.', 'Error');
        }
      }
    });
  }

  initForm() {
    this.searchBox = this.fb.group({
      search: ['']
    });
  }

  searchProfiles(event: any) {
    this.payload.page = 1;
    this.payload.name = this.searchBox.value.search;
    this.loadProfiles(this.payload);
  }

  pageChanged(event: any) {
    this.payload.page = event;
    this.loadProfiles(this.payload);
  }

  tag(status: any) {
    if (status === 'active') {
      return 'Activo';
    } else {
      return 'Inactivo';
    }
  }
}
